import { render, staticRenderFns } from "./VinQueryLog.vue?vue&type=template&id=870f313e&"
import script from "./VinQueryLog.vue?vue&type=script&lang=js&"
export * from "./VinQueryLog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports